import { BailHearingDecision, BailRight, BailRightFeedback } from "types";
import apiClient from "../lib/apiClients";

// BailRight
export const fetchBailRight = async () => {
  const response = await apiClient.get<BailRight[]>("/bail_right/bail-rights/");
  return response.data;
};
export const fetchBailRightByRole = async (
  admin_unit_id: string | number,
  role: string,
) => {
  const response = await apiClient.get<BailRight[]>(
    `/bail_right/bail-rights/by-coordinator-role/?admin_unit_id=${admin_unit_id}&coordinator_role=${role}`,
  );
  return response.data;
};
export const fetchBailRightByAssignedProsecutor = async (
  prosecutor_id: string | number,
) => {
  const response = await apiClient.get<BailRight[]>(
    `/bail_right/bail-rights/by-assigned-prosecutor/?assigned_prosecutor_userid=${prosecutor_id}`,
  );
  return response.data;
};
export const fetchBailRightById = async (id: string) => {
  const response = await apiClient.get<BailRight>(
    "/bail_right/bail-rights/" + id + "/",
  );
  return response.data;
};
export const addBailRight = async (data: BailRight) => {
  const response = await apiClient.post("/bail_right/bail-rights/", data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data;
};
export const editBailRight = async (data: any) => {
  const response = await apiClient.patch(
    "/bail_right/bail-rights/" + data?.uu_id + "/",
    data,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    },
  );
  return response.data;
};
export const editBailRight2 = async (data: any) => {
  const response = await apiClient.patch(
    "/bail_right/bail-rights/" + data?.uu_id + "/",
    data,
  );
  return response.data;
};
export const deleteBailRight = async (reporter: BailRight) => {
  const response = await apiClient.delete(
    "/bail_right/bail-rights/" + reporter?.uu_id + "/",
  );
  return response.data;
};

//BailRightFeedback
export const addBailRightFeedback = async (data: BailRightFeedback) => {
  const response = await apiClient.post(
    "/bail_right/bail-coordinator-feedbacks/",
    data,
  );
  return response.data;
};

// BailHearingDecision
export const fetchBailHearingDecision = async () => {
  const response = await apiClient.get<BailHearingDecision[]>(
    "/bail_right/bail-hearing-decisions/",
  );
  return response.data;
};
export const fetchBailHearingDecisionByBailRightId = async (id: number) => {
  const response = await apiClient.get<BailHearingDecision[]>(
    "/bail_right/bail-hearing-decisions/by-bail-right/" + id + "/",
  );
  return response.data;
};
export const addBailHearingDecision = async (data: BailHearingDecision) => {
  const response = await apiClient.post(
    "/bail_right/bail-hearing-decisions/",
    data,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    },
  );
  return response.data;
};
export const editBailHearingDecision = async (data: any) => {
  const response = await apiClient.patch(
    "/bail_right/bail-hearing-decisions/" + data?.uu_id + "/",
    data,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    },
  );
  return response.data;
};
export const editBailHearingDecision2 = async (data: any) => {
  const response = await apiClient.patch(
    "/bail_right/bail-hearing-decisions/" + data?.uu_id + "/",
    data,
  );
  return response.data;
};
export const deleteBailHearingDecision = async (
  reporter: BailHearingDecision,
) => {
  const response = await apiClient.delete(
    "/bail_right/bail-hearing-decisions/" + reporter?.uu_id + "/",
  );
  return response.data;
};
